import React from 'react';
import { Context } from './Form';
import Select from 'components/Select';
import getFromObj from 'util/getFromObj';
import { view } from 'react-easy-state';

const FormSelect = (props) => (
  <Context.Consumer>
    {(context) => {
      let curValue = getFromObj(context.value, props.field);
      if(curValue === undefined){
        if(props.default !== undefined) {
          context.updateValue(props.field, props.default);
          curValue = props.default;
        } else {
          curValue = '';
        }
      }
      return (
        <Select {...props} value={curValue} onChange={ (event) => { 
          context.updateValue(props.field, event.target.value);
          if(props.onChange) props.onChange(event.target.value);
        } } />
      )
    } }
  </Context.Consumer>
);

export default view(FormSelect);